import React from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { ArrowLeftOutlined } from "@ant-design/icons";
import s from "./BackLink.module.scss";

// Goes back in history; on a direct visit / refresh there is no previous
// page in the app, so it falls back to the list page
const BackLink = ({ fallback, children = "Back", className = "" }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const hasHistory = location.key !== "default";

  return (
    <Link
      to={fallback}
      className={`${s.back} ${className}`}
      onClick={(e) => {
        if (hasHistory) {
          e.preventDefault();
          navigate(-1);
        }
      }}
    >
      <ArrowLeftOutlined className={s.icon} />
      {children}
    </Link>
  );
};

export default BackLink;
